(function ($) {
  $(document).ready(function () {
    $(".resource-card .tabs-wrap .tab").click(function () {
      $(".resource-card .tabs-wrap .tab, .resource-card .row-wrap .card").removeClass("active");
      $(this).addClass("active");
      var tabId = $(this).data("tab");
      $("#" + tabId).addClass("active");
    });
  });
})(jQuery);
  